import { render, staticRenderFns } from "./Restrictions.vue?vue&type=template&id=31c34bf3&scoped=true"
import script from "./Restrictions.vue?vue&type=script&lang=js"
export * from "./Restrictions.vue?vue&type=script&lang=js"
import style0 from "./Restrictions.vue?vue&type=style&index=0&id=31c34bf3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31c34bf3",
  null
  
)

export default component.exports